import React from 'react';
import PropTypes from 'prop-types';
import ModuleHeader from './ModuleHeader';

const FallbackModule = ({
  heading,
  message,
  buttonCopy,
  link,
  themeClassName,
}) => (
  <div className={`fallback-module page-module ${themeClassName} py-5 px-2 px-auto-md`}>
    <div className="container my-auto">
      <ModuleHeader header={heading} />
      <div className="row">
        <div className="no-scores col-12">
          <p>{message}</p>
          {link && (
            <>
              <br />
              <p>
                <a className="btn btn-secondary" href={link}>
                  {buttonCopy}
                </a>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  </div>
);

FallbackModule.defaultProps = {
  themeClassName: 'module-navy',
  link: null,
};

FallbackModule.propTypes = {
  heading: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttonCopy: PropTypes.string.isRequired,
  link: PropTypes.string,
  themeClassName: PropTypes.string,
};

export default FallbackModule;
